import React from "react";
import styles from "./style.module.scss";

import StatisticsTabs from "../components/StatisticsTabs/StatisticsTabs";
import ServiceIndicators from "../components/ServiceIndicators/ServiceIndicators";

function StatisticsPage() {
  return (
    <div className={styles.statistics}>
      <div className={styles.statistics_page}>
        <h1 className={styles.statistics_page_title}>Статистика</h1>
      </div>
      <StatisticsTabs />
      <ServiceIndicators />
    </div>
  );
}

export default StatisticsPage;
